export function createMessage() {
  switch (arguments[0]) {
    case 'auth':
      return JSON.stringify({
        service: 'auth',
        data: { session_id: arguments[1], login_params: 'orbital.stellar' },
      })
    case 'settings':
      return JSON.stringify({ service: 'settings', data: arguments[1] })
    case 'bet':
      return JSON.stringify({
        service: 'bet',
        data: { amount: arguments[1], index: arguments[2], auto: arguments[3] },
      })
    case 'cashout':
      return JSON.stringify({ service: 'cashout', data: { index: arguments[1] } })
    case 'jackpot':
      return JSON.stringify({ service: 'jackpot', data: { index: arguments[1] } })
    case 'jackpotstep':
      return JSON.stringify({ service: 'jackpotstep', data: { index: arguments[1] } })
    case 'fullround':
      return JSON.stringify({ service: 'fullround', data: { } })
    default:
      break
  }
  return
}
